import React from 'react'
import { Typography, IconButton, Box } from '@mui/material';
import { getTabData } from '../../../../helpers';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { dataConstants } from '../../../../constants';
import ShareThis from '../../../_common/ShareThis';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })
import CollapseCard from '../../CollapseCard';

const { ECO_SECTION_CODES } = dataConstants || {};

function Consumption({ data, sumData, onChangeInfo, handleClick, getChartData, selectedInfo, themes }) {

  //consumption
  const consumption = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.GLA_CONSUMPTION) : undefined;
  const consumptionChart = consumption && consumption.tabData ? getChartData(consumption.tabData, getTabData(sumData, consumption, ECO_SECTION_CODES.GLA_DATA)) : undefined;

  return (
    <>
      {consumption &&
        <Box component="div" className="col-md-4" sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box component="div">
            <Box
              className="section"
              sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 1.4,
                px: 0.5,
              }}
            >
              <Typography component="h4" className="option-title" sx={{ mr: 'auto' }} >
                {consumption.section_name}
              </Typography>
              {/* <IconButton aria-label="info" onClick={() => onChangeInfo(consumption.section_code)}>
                <InfoRoundedIcon size="small" sx={{ fontSize: '1.2rem', color: 'text.link' }} />
              </IconButton> */}
              <ShareThis
                // link={url}
                link={encodeURI(`${process.env.NEXT_PUBLIC_URL}${dataConstants.NAVS.CHART_SHARE}/${consumptionChart?.code}/${consumptionChart?.series.map(d => d.yformula).join(';')}/${consumption.section_name}`)}
                title={`${consumption.section_name}`}
                message={`${consumption.section_name}`}
                subject={''}
              />
            </Box>
            {consumptionChart && consumptionChart.description && <Box component="div" className="option-desc" sx={{ mb: 2, px: 2 }}><Typography variant="caption" sx={{ color: 'text.description' }} dangerouslySetInnerHTML={{ __html: consumptionChart.description }} /></Box>}
          </Box>
          <Box component="div">
            <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', pr: 2, minHeight: '12rem' }}>
              <D3Chart
                showChart={true}
                noHeader
                // maxHeight={chartProps.maxHeight}
                scale={1}
                // onClick={code => handleClick(code)}
                chart={{ ...consumptionChart, id: consumption.section_code, tick: 2 }}
                // userName={`@${chart.code.split('@')[1]}`}
                themes={themes}
                type={dataConstants.CHART_STATE.VIEW}
                // axisTextMargin={chartProps.axisTextMargin}
                chartMargin={{ left: 40, bottom: 48 }}
                axisTextMargin={{ y: 108 }}
                // wrapperClass="StockCardImage"
                //showLegend={false}
                showCrosshair
              />
            </Box>
            <CollapseCard
              selectedInfo={selectedInfo}
              section_code={consumption?.section_code}
              chart_codes={consumptionChart}
              handleClick={handleClick}
            />
          </Box>
        </Box>}
    </>
  )
}

export default Consumption
